interface EmptyProps {
  title?: string;
  message?: string;
}

export const Empty = ({ title, message }: EmptyProps) => {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-white p-8 text-center">
      <p className="text-lg font-medium text-gray-700">{title ?? 'No results found'}</p>
      {message && <p className="mt-1 text-sm text-gray-500">{message}</p>}
    </div>
  );
};
